<template>
  <div class="jsc-bg">
    <!-- 顶部 -->
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">体育驾驶舱首页</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <!-- 中间 -->
    <my-scale @changeSize="changeSize">
      <div class="d-aligncnter" style="width: 1920px; height: 1000px; margin-top: 104px">
        <div class="d-allcenter" style="flex-direction: column; justify-content: space-evenly; height: 100%">
          <!-- <div @click="changePage('cockpit')">跑步驾驶舱</div> -->
          <!-- <div @click="changePage('academic')">学业预警驾驶舱</div> -->
          <div class="models" style="width: 1500px">
            <div class="d-column" @mouseenter="currHover = 1" @mouseleave="currHover = 0">
              <!-- <div class="modelimg d-allcenter" @click="changePage('academic')"> -->
              <div class="modelimg d-allcenter" @click="changePage('attendance')">
                <img
                  :src="
                    currHover == 1
                      ? require('@/assets/img/cockpitindex/Item1light.svg')
                      : require('@/assets/img/cockpitindex/Item1.svg')
                  "
                />
              </div>
              <!-- <div class="model-name" @click="changePage('academic')">学业预警</div> -->
              <div class="model-name" @click="changePage('attendance')">考勤预警</div>
            </div>
            <div class="d-column" @mouseover="currHover = 2" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('sport')">
                <img
                  :src="
                    currHover == 2
                      ? require('@/assets/img/cockpitindex/Item2light.svg')
                      : require('@/assets/img/cockpitindex/Item2.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('sport')">课外锻炼</div>
            </div>
            <div class="d-column" @mouseover="currHover = 3" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('test')">
                <img
                  :src="
                    currHover == 3
                      ? require('@/assets/img/cockpitindex/Item3light.svg')
                      : require('@/assets/img/cockpitindex/Item3.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('test')">体质健康</div>
            </div>
            <div class="d-column" @mouseover="currHover = 4" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('competition')">
                <img
                  :src="
                    currHover == 4
                      ? require('@/assets/img/cockpitindex/Item5light.svg')
                      : require('@/assets/img/cockpitindex/Item5.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('competition')">体育竞赛</div>
            </div>
          </div>
          <div class="models">
            <div class="d-column" @mouseover="currHover = 5" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('sportteam')">
                <img
                  :src="
                    currHover == 5
                      ? require('@/assets/img/cockpitindex/Item6light.svg')
                      : require('@/assets/img/cockpitindex/Item6.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('sportteam')">运动竞训</div>
            </div>
            <div class="d-column" @mouseover="currHover = 6" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('clubcockpit')">
                <img
                  :src="
                    currHover == 6
                      ? require('@/assets/img/cockpitindex/Item7light.svg')
                      : require('@/assets/img/cockpitindex/Item7.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('clubcockpit')">社团活动</div>
            </div>
            <div class="d-column" @mouseover="currHover = 7" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('heartrate')">
                <img
                  :src="
                    currHover == 7
                      ? require('@/assets/img/cockpitindex/Item8light.svg')
                      : require('@/assets/img/cockpitindex/Item8.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('heartrate')">教学班心率</div>
            </div>
            <div class="d-column" @mouseover="currHover = 8" @mouseleave="currHover = 0">
              <div class="modelimg d-allcenter" @click="changePage('venuesorder')">
                <img
                  :src="
                    currHover == 8
                      ? require('@/assets/img/cockpitindex/Item9light.svg')
                      : require('@/assets/img/cockpitindex/Item9.svg')
                  "
                />
              </div>
              <div class="model-name" @click="changePage('venuesorder')">场馆预约</div>
            </div>
          </div>
        </div>
      </div>
    </my-scale>

    <!-- 底部 -->
  </div>
</template>
<script>
import 'swiper/css/swiper.css'
import MyScale from './components/MyScale.vue'
export default {
  name: '',
  components: {
    MyScale,
  },
  directives: {},
  data() {
    return {
      today: '',
      hoursData: [],
      dayCollegeData: [],
      monthCollegeData: [],
      monthData: [],
      monthError: [],
      monthColleges: [],
      semesterData: [],
      semesterDisData: [],
      colleges: [],
      lastSum: '',
      activeSum: '',
      activeTodaySum: '',
      venueData: [
        { venueName: '锻炼场', number: 15 },
        { venueName: '锻炼场', number: 18 },
      ],
      sloganData: [
        { lineOne: '体育无处不在', lineTwo: '运动无限精彩' },
        { lineOne: '你心我心运动同心', lineTwo: '你行我行健康同行' },
        { lineOne: '体育生活化', lineTwo: '生活体育化' },
      ],
      sloganIndex: 0,
      abnormalData: [
        // {
        //   name: '张三',
        //   phone: '15268889789',
        //   place: '风雨操场',
        // },
      ],
      timer: null,
      centerShow: false,
      leftShow: false,
      rightShow: false,
      currHover: 0,
      mySize: 5.208,
      currScale: 1,
    }
  },
  created() {
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
  },
  mounted() {
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changePage(pageName) {
      this.$router.push({
        path: '/cockpit/' + pageName,
        query: {},
      })
    },
    changeSize(size) {
      console.log('change??')
      this.currScale = size
      this.mySize = this.mySize / size
      //   const observer = new IntersectionObserver(callback, options)
      //   const callback = (entries, observer) => {
      //     entries.forEach((element) => {
      //       console.log(
      //         'element.IntersectionObserver',
      //         element.IntersectionObserver
      //       )
      //     })
      //   }
      //   const options = {}

      //   const target = document.getElementsByClassName('models')[0]
      //   observer.observe(target)
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>
<style scoped lang="scss">
.swiper {
  height: 100%;
  width: 100%;
}
.slide-show-content {
  width: 30vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.swiper-slide {
  width: 30vw !important;
}
.swiper-container {
  width: 30vw !important;
}
.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  background: url('../../assets/img/cockpit/indexbg.png') no-repeat;
  background-size: 100% 100%;
  background-color: #09120f;
  color: #fff;
  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;
    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }
    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }
    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }
    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
  .center {
    .center-left,
    .center-right {
      width: 30%;
      //   width: 26%;
      height: 66vh;
      //   border: 1px solid #fff;
    }
    .center-center {
      width: 40%;
      //   width: 48%;
      height: 66vh;
      //   border: 1px solid #fff;
    }
  }
  .bottom {
    width: calc(100vw - 2px);
    // min-width: 1200px;
    height: calc(34vh - 5.208vw - 5px);
    // border: 1px solid #fff;
  }
}
.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}
.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}
.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
.slog {
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.modelimg {
  position: relative;
  :hover {
    cursor: pointer;
  }
  img {
    position: absolute;
    width: 392px;
    height: 349px;
    :hover {
      cursor: pointer;
    }
  }
}
.model-name {
  margin-top: 180px;
  :hover {
    cursor: pointer;
  }
}
.models {
  //   width: 100vw;
  width: 1920px;
  display: flex;
  justify-content: space-evenly;
  .d-column {
    :hover {
      cursor: pointer;
    }
  }
}
</style>
